@if (dialogOpen) {
    <div class="dialog-backdrop" (click)="closeDialog()"></div>
    <div class="dialog-container">
        <div class="dialog-header">
            @if (icon) {
                <mat-icon class="header-icon" [svgIcon]="icon"></mat-icon>
            }
            <div class="header-title">
                <ng-content select="[header-title]"></ng-content>
            </div>
            <div class="header-close" (click)="closeDialog()"></div>
        </div>
        <div class="dialog-content">
            <ng-content select="[dialog-content]"></ng-content>
        </div>
        <div class="dialog-footer">
            <ng-content select="[dialog-footer]"></ng-content>
        </div>
    </div>
}
